import React from "react";

export const Loading = () => <img className={"center"} src={document.configuration.STATIC_FILE_LOCATION+"img/loading_airplane.gif"} alt="loading..."/>;
